import { CircleDot, Zap, Layers, Globe } from "lucide-react";

import { ToolbarTriggerButton, DropdownPanel } from "./_shared";

export const AGENT_ICON_COMPONENT = {
  MAIN: Zap,
  DISCOVERY: Layers,
  WWWSEARCH: Globe,
};

export const AgentIcon = ({
  agent,
  size = 20,
  strokeWidth = 1.5,
  className = "",
}) => {
  const Icon = AGENT_ICON_COMPONENT[agent] || CircleDot;
  return <Icon size={size} strokeWidth={strokeWidth} className={className} />;
};

const DropDownAgentSelector = (props) => {
  const apiName = props.selectedAgent?.apiName;

  const handleToggle = () => {
    props.setIsAgentSelectorOpen(!props.isAgentSelectorOpen);
    props.setIsDropDownNotesOpen(false);
    props.setIsPromptLoaderOpen(false);
  };

  const SelectedAgentToolbarIcon = ({ className = "" }) => (
    <AgentIcon
      agent={apiName}
      size={14}
      strokeWidth={1.75}
      className={["text-velBlue", className].filter(Boolean).join(" ")}
    />
  );

  return (
    <div className="relative">
      <ToolbarTriggerButton
        icon={SelectedAgentToolbarIcon}
        label={props.selectedAgent?.name || "Agent"}
        onClick={handleToggle}
        active={props.isAgentSelectorOpen}
      />

      <DropdownPanel
        isOpen={props.isAgentSelectorOpen}
        width="w-[420px] max-w-[calc(100vw-2rem)]"
        maxHeightClass="max-h-[70vh]"
      >
        <div className="p-2">
          <ul className="space-y-1">
            {props.agents.map((agent) => {
              const selected = props.selectedAgent?.apiName === agent.apiName;

              return (
                <li key={agent.apiName}>
                  <button
                    type="button"
                    onClick={() => {
                      props.setSelectedAgent(agent);
                      props.setIsAgentSelectorOpen(false);
                    }}
                    className={[
                      "group flex w-full items-start gap-3 rounded-lg px-3 py-3 text-left",
                      "transition-colors cursor-pointer",
                      "outline-none focus-visible:ring-2 focus-visible:ring-inputFocus/60",
                      selected ? "bg-velBlue/10" : "hover:bg-btnHover",
                    ].join(" ")}
                  >
                    <span className="mt-0.5 shrink-0 h-10 w-10 rounded-full bg-velBlue/10 border border-velBlue/20 flex items-center justify-center">
                      <AgentIcon
                        agent={agent.apiName}
                        size={20}
                        className="text-velBlue"
                      />
                    </span>

                    <div className="min-w-0 flex-1">
                      <div className="flex items-start gap-2">
                        <p className="min-w-0 flex-1 text-[13px] font-light text-mainText whitespace-normal break-words">
                          {agent.name}
                        </p>

                        {selected && (
                          <span className="shrink-0 rounded-full bg-velBlue/15 px-2 py-px text-[10px] font-light text-velBlue uppercase tracking-wider">
                            Active
                          </span>
                        )}
                      </div>

                      <p className="mt-1.5 text-[12px] leading-5 font-light text-mutedText whitespace-normal break-words">
                        {agent.description}
                      </p>
                    </div>
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      </DropdownPanel>
    </div>
  );
};

export default DropDownAgentSelector;
